import React from 'react'
import { I18n } from '@front/volcanion/'

import { TextField, ModelMenuSelectorField, MenuSelectorField, ModelAutocompleteField } from '@front/squirtle/'
import { Typography, Grid, Box, StepLabel, StepContent } from '@mui/material'

import FormatUtils from '@front/squirtle/utils/format'
import { SuspensionTitleForm } from '@abra/elements/Suspensions'

const Row1 = ({ verifyUsername }) =>
  <Grid container spacing={2} size={12}>
    <Grid size={4}>
      <TextField name={'auth.username'} label={I18n.t('user.username')} required afterUserChange={verifyUsername} debounceTime={250} />
    </Grid>
    <Grid size={4}>
      <TextField name={'info.last_name'} label={I18n.t('name.label', { count: 1 })} required />
    </Grid>
    <Grid size={4}>
      <TextField name={'info.first_name'} label={I18n.t('name.first_name', { count: 1 })} required />
    </Grid>
  </Grid>

const Row2 = ({
  isManagingRecord,
  statusChange,
  color,
  verifyEmail,
}) =>
  <Grid container spacing={2} size={12}>
    <Grid size={4}>
      <ModelMenuSelectorField
        name='auth.role'
        label={I18n.t('user.role')}
        model_name='role'
        labelKeys={['name']}
        loadOnMount
        searchMode={'search'}
        required
      />
    </Grid>
    <Grid size={4}>
      <TextField name={'auth.email'} label={I18n.t('email.label', { count: 1 })} afterUserChange={verifyEmail} debounceTime={250} />
    </Grid>
    <Grid size={4}>
      <MenuSelectorField
        label={I18n.t('status.label', { count: 1 })}
        name={'status'}
        options={_.compact([
          { label: <Box sx={{ color: 'green', fontWeight: 500 }}> {I18n.t('status.active')}  </Box>, value: 'active' },
          { label: <Box sx={{ color: 'red', fontWeight: 500 }}> {I18n.t('status.deleted')}  </Box>, value: 'deleted', disabled: !isManagingRecord },
          { label: <Box sx={{ color: 'orange', fontWeight: 500 }}> {I18n.t('status.suspended')}  </Box>, value: 'suspended', disabled: !isManagingRecord },
        ])}
        valueDecoratorProps={{
          sx: { WebkitTextFillColor: color, fontWeight: 600 }
        }}
        selectFirst
        required
        afterChange={statusChange}
      />
    </Grid>
  </Grid>

const Row3 = ({ supported_languages }) =>
  <Grid container spacing={2} size={12}>
    <Grid size={4}>
      <MenuSelectorField
        name={'info.preferred_language'}
        label={I18n.t('lang', { count: 1 })}
        options={_.map(supported_languages, (lang, index) => ({
          label: (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={{ mr: 1, display: 'flex', alignItems: 'center' }}>{FormatUtils.getFlagIcon(lang)}</Box>
              <Typography> {_.upperCase(lang)} </Typography>
            </Box>
          ),
          value: lang
        }))}
        required
      />
    </Grid>
    <Grid size={4}>
      <ModelAutocompleteField
        name={'staffinfo.city'}
        label={I18n.t('city.label', { count: 1 })}
        model_name={'city'}
        searchQuery={'contains'}
        autocompleteKey={'name'}
        labelKeys={['name_translated']}
        config={{
          initial_filter: {},
          sortBy: ['name_translated'],
          sortDirection: ['asc']
        }}
        searchMode={'search'}
        required
        selectFirst={false}
      />
    </Grid>
  </Grid>


const PrimarySection = ({
  user_auth_id,
  supported_languages,
  isManagingRecord,
  color,
  verifyUsername,
  statusChange,
  verifyEmail,
}) => (
  <>
    <StepLabel>
      <SuspensionTitleForm label={I18n.t('info.general')} record_id={user_auth_id} />
    </StepLabel>
    <StepContent>
      <Box sx={{ p: 5, boxShadow: 6, borderRadius: 3 }}>
        <Grid container rowSpacing={3}>
          <Row1 verifyUsername={verifyUsername} />
          <Row2
            isManagingRecord={isManagingRecord}
            statusChange={statusChange}
            color={color}
            verifyEmail={verifyEmail}
          />
          <Row3 supported_languages={supported_languages} />
        </Grid>
      </Box>
    </StepContent>
  </>
)

export default React.memo(PrimarySection)
